<template>
  <vs-popup :active="isActive" title="Create or edit" v-on:update:active="UpdateActive" :class="(IsSidePopUp && IsSidePopUp === true) || IsSidePopUp === 'true'
    ? 'side-popup'
    : ''
    ">
    <div class="vx-row">
      <div class="vx-col w-full lg:w-1/1">
        <!-- <span v-if="AISkillsStats" style="float:right; font-size:8px;">Resolving skills {{AISkillsStats.currentPage}} of {{AISkillsStats.totalPages}}</span> -->
        <a v-if="SkillsWithBreadCrumbs != null" ref="aiassist" style="float: right; cursor: pointer"
          @click="OpenAIExplain">AI Assist</a>
        Title:<br />
        <vs-input required class="w-full" v-model="currentItem.Title" /><br />
      </div>
    </div>
    <div class="vx-row">
      <div class="vx-col w-full">
        Description:<br />
        <quillEditor v-model="currentItem.Description"></quillEditor>
      </div>
      <div class="vx-col w-full">
        Tags:
        <br />
        <RelatedItemsDropdown @update:selectedItems="tagsUpdated" :selectedItems="currentItem.RelatedTags"
          RelatedItemsType="DataModel.TCVelik.Taxonomy.TCTag" RelatedParentType="DataModel.TCVelik.Embed.TCEmbed"
          :RelatedParentId="currentItem.Id" typeName="DataModel.TCVelik.Embed.TCEmbed"
          :GetItemsPromise="tagsService.getTags" :commitItemsPromise="tagsService.commitTags"></RelatedItemsDropdown>
        <br />
      </div>
    </div>

    <vs-collapse class="embed-actions">
      <vs-collapse-item>
        <div slot="header">Relations &amp; Assignments</div>
      </vs-collapse-item>
      <vs-collapse-item>
        <div slot="header">Additional Content</div>
        <div class="vx-col w-full">
          Keywords (comma-separeted):<br />
          <textarea v-model="currentItem.Keywords" style="width: 100%"></textarea>
        </div>
        <div class="vx-col w-full">
          <vs-checkbox v-model="AllowNotifyChecked">Notify {{ this.EmailsToNotify }} by email or messanger
          </vs-checkbox>
        </div>
        <div class="vx-col w-full lg:w-1/2">
          Under: <br />
          <vue-simple-suggest class="vue-simple-suggest" v-model="currentItem.EmbedArea" value-attribute="Data.FullPath"
            display-attribute="Data.FullPath" :list="EmbedAreasFilters" key="suggestion.Data.FullPath"
            :filter-by-query="true">
            <div slot="suggestion-item" slot-scope="{ suggestion }">
              <div v-if="suggestion && suggestion.Title">
                <div>{{ suggestion.Title }}</div>
                <small>in <strong>{{ suggestion.Data.FullPath }}</strong></small>
              </div>
            </div>
          </vue-simple-suggest>
          <br />
        </div>
        <div class="vx-col w-full lg:w-1/2">
          Slug:
          <vs-checkbox style="float: right" v-model="AutoSlug">Auto</vs-checkbox><br />
          <vs-input class="w-full" v-model="currentItem.Slug" /><br />
        </div>
      </vs-collapse-item>
      <vs-collapse-item>
        <div slot="header">
          Skills &amp; Gap Analysis ({{
    this.AIResolvedSkillset ? AIResolvedSkillset.length : 0
  }}):
          {{
      this.AISkillsStats
        ? "(Processing " +
        this.AISkillsStats.currentPage +
        " of " +
        this.AISkillsStats.totalPages +
        ")"
        : ""
    }}
        </div>
        <div class="vx-col w-full">
          <div v-if="AIResolvedSkillset">
            <h4 class="gap-section-title">Must:</h4>
            <SkillExpandable :key="'inf_skill' + skill.Id" v-for="skill in MustSkills" :Skill="skill"
              AutoLoadForCurrentUser="true">
              <div slot="PostSkill" style="margin-left: 32px">
                <small><small><strong>Explanation: </strong>{{ skill.Explanation }}</small></small>
              </div>
            </SkillExpandable>

            <!-- NCE TO HAVE -->
            <h4 class="gap-section-title">Nice to have:</h4>
            <SkillExpandable :key="'inf_skill' + skill.Id" v-for="skill in NiceToHaveSkills" :Skill="skill"
              AutoLoadForCurrentUser="true">
              <div slot="PostSkill" style="margin-left: 32px">
                <small><small><strong>Explanation:</strong>{{ skill.Explanation }}</small></small>
              </div>
            </SkillExpandable>

            <!-- NCE TO HAVE -->
            <h4 class="gap-section-title">New Proposals:</h4>
            <SkillExpandable :key="'inf_skill' + skill.Id" v-for="skill in CreateSkills" :Skill="skill"
              AutoLoadForCurrentUser="true">
              <div slot="PostSkill" style="margin-left: 32px">
                <small><small><strong>Explanation:</strong>{{ skill.Explanation }}</small></small>
              </div>
            </SkillExpandable>

            <!-- <div v-for="skill in AIResolvedSkillset" :key="skill.Id">
              <div v-if="skill.Title">
                <a
                  style="font-size: 12px; font-weight: bold"
                  :href="GetSkillLink(skill.Id)"
                >
                  [{{ skill.RelationType }}] {{ skill.Title }} </a
                ><br />
                {{ skill.Explanation }}
              </div>
            </div> -->
          </div>
        </div>
      </vs-collapse-item>
      <vs-collapse-item>
        <div slot="header">Advanced Information</div>
        <div v-if="!TriggerUrl">
          <div class="vx-col w-full">
            <strong>File:</strong>
            <br />
            {{ currentItem.RelativeFileName }}<br />
          </div>
          <div class="vx-col w-full">
            <br /><strong>CommitId:</strong> <br />
            <span class="w-full" style="overflow: hidden; max-width: 100%"
              v-html="currentItem.CommitId"></span><br /><br />
          </div>
          <div class="vx-col w-full">
            <strong>Branch:</strong> <br />
            <span class="w-full" style="overflow: hidden" v-html="currentItem.Branch"></span><br /><br />
          </div>
        </div>
        <div v-if="TriggerUrl && TriggerUrl.length > 0">
          Url: {{ TriggerUrl }}
        </div>
      </vs-collapse-item>
    </vs-collapse>

    <div class="vx-row"></div>

    <div class="vx-row"></div>

    <div class="vs-popup-footer">
      <vs-button color="primary" type="filled" style="margin-top: 10px" class="mb-3" @click="Save">Save &amp;
        Close</vs-button>&nbsp;<vs-button color="primary" type="filled" style="margin-top: 10px" class="mb-3"
        @click="Save(false)">Save</vs-button>
    </div>
  </vs-popup>
</template>
<script>
import "quill/dist/quill.core.css";
import "quill/dist/quill.snow.css";
import "quill/dist/quill.bubble.css";
import { quillEditor } from "vue-quill-editor";
import VueSimpleSuggest from "vue-simple-suggest";
import RelatedItemsDropdown from "@/views/components/extra-components/RelatedItems/RelatedItemsDropdown.vue";
import TagsService from "@/tags/tagsService.js";
import TagList from "@/views/components/extra-components/taglist/TagList.vue";
import OpenAIClient from "@/openai/OpenAIClient.js";
import SkillsService from "@/skills/skillsService.js";
import SkillExpandable from "@/views/components/extra-components/skills/SkillExpandable.vue";
import accountsService from "../../../../accounts/accountsService";
  

export default {
  data() {
    return {
      embedLinkData: null,
      currentUrl: null,
      EmbedAreasFilters: [],
      tagsService: TagsService,
      AutoSlug: true,
      IsAiLoading: false,
      SkillsWithBreadCrumbs: null,
      AIResolvedSkillset: null,
      AISkillsStats: null,
      MustSkills: [],
      NiceToHaveSkills: [],
      CreateSkills: [],
    };
  },
  mounted() {
    this.getSkillsWithBreadCrumbs();
  },
  methods: {
    getSkillsWithBreadCrumbs() {
      var instance = this;

      if (!window.SkillsWithBreadCrumbs) {
        SkillsService.GetSkillWithBreadCrumbs().then(function (response) {
          instance.$set(instance, "SkillsWithBreadCrumbs", response.data);
          window.SkillsWithBreadCrumbs = response.data;
        });
      } else {
        this.$set(this, "SkillsWithBreadCrumbs", window.SkillsWithBreadCrumbs);
      }
    },
    GetSkillLink(id) {
      // "/dashboard/skill-details/670?forUser=1"
      var currentUser = accountsService.getUserFromLocalStorage();
      return SkillsService.getSkillLinkForUser(id, currentUser.User.Id);
    },
    tagsUpdated(newVal) {
      this.$set(this.currentItem, "RelatedTags", newVal);
    },
    async OpenAIExplain() {

      var instance = this;
      var textToExplain = this.currentItem.RawText;

      var pageSize = 50;
      var skillPages = instance.SkillsWithBreadCrumbs.Skills.length / pageSize;
      var currentPage = 1;

      instance.$set(instance, "AIResolvedSkillset", []);

      while (currentPage < skillPages) {
        var skillsToSend = instance.SkillsWithBreadCrumbs.Skills.slice(
          (currentPage - 1) * pageSize,
          currentPage * pageSize
        );

        instance.$set(instance, "AISkillsStats", {
          totalPages: Math.round(skillPages),
          currentPage: currentPage,
        });

        var relativeFileName = instance.currentItem.RelativeFileName;
        var promptFile = relativeFileName
          ? "File name of this code is " +
          relativeFileName +
          ". This should help you properly identify platform and langauges."
          : "";

        var propmptSkills =
          'You are only allowed to return answers in this format, do not add any other text in your answers. If you can not generate them:{"Explanation": "any explanation", "Skills":[{"Id":The Id of the selected item or -1 if you are proposing a missing skill, "Explanation": "Very short why the skill was selected", "RelationType":"MUST if the skill is used in the file and NICE TO HAVE if it is possible to be used or helpful or CREATE if the skill does not exist yet."}]}. I am giving you a list of skills and code, you need to match what skills the code needs:\n Only return skills that you can see in the code and propose skills that are frequent in it and critical to understand it but do not exist in the skills list.' +
          promptFile +
          JSON.stringify(skillsToSend, null, 3) +
          "\nCode:\n" +
          textToExplain +
          "\nIf the file langauge and the skill breadcrumb do not match - skip it. IMPORTANT: If you cannot match skills - return EMPTY JS ARRAY ONLY, NOTNING ELSE!";

        await OpenAIClient.promptRaw(propmptSkills, null).then(function (
          response
        ) {
          var aiResponse = response.data;
          try {
            var JSONWrapperObj = JSON.parse(aiResponse);

            var descriptionFinal = JSONWrapperObj.choices[0].message.content;

            try {
              var massagedArray = instance.MassageAIReolvedSkillSet(
                JSON.parse(descriptionFinal).Skills,
                instance
              );
              instance.$set(
                instance,
                "AIResolvedSkillset",
                instance.AIResolvedSkillset.concat(massagedArray)
              );
            } catch (err) {
              console.error("TCV1: ", err, descriptionFinal);
            }
          } catch {
            console.error("TCV1: ", descriptionFinal);
          }
        });

        currentPage++;
      }

      instance.$set(instance, "AISkillsStats", null);
    },
    GetSkillRelations() {
      return this.AIResolvedSkillset;
    },
    MassageAIReolvedSkillSet(skillCategories, instance) {
      var enhancedResult = skillCategories
        .map((skillCategory) => {
          var skillCategoryData = instance.SkillsWithBreadCrumbs.Skills.find(
            (c) => c.Id.toString() == skillCategory.Id.toString()
          );
          if (skillCategoryData) {
            skillCategoryData.MyScores = 0;
            return { ...skillCategoryData, ...skillCategory };
          }
        })
        .filter((itm) => itm != null && typeof itm != typeof undefined);

      if (!enhancedResult || enhancedResult.length == 0) return [];

      return enhancedResult;
    },
    FilterSkillsByRelationType(relationType) {
      var result = this.AIResolvedSkillset.filter(
        (f) => f.RelationType == relationType
      );
      return result;
    },
  },
  watch: {
    currentItem: {
      handler(newVal, oldVal) {
        var instance = this;
        if (
          newVal &&
          newVal.StartLine &&
          newVal.EndLine &&
          newVal.StartColumn &&
          newVal.EndColumn &&
          newVal.Project &&
          newVal.RelativeFileName &&
          newVal.CommitId
        ) {
          this.$set(this, "currentUrl", window.location.href);

          var previewLink =
            window.location.protocol +
            "//" +
            window.location.host +
            "/" +
            "embed.html#/" +
            1 + // TODO!!!!
            "/" +
            newVal.Project +
            "/" +
            encodeURIComponent(newVal.RelativeFileName) +
            "/" +
            newVal.StartLine +
            "/" +
            newVal.StartColumn +
            "/" +
            newVal.EndLine +
            "/" +
            newVal.EndColumn +
            "/" +
            newVal.CommitId +
            "/";
          this.$set(this, "embedLinkData", previewLink);
        }
        if (newVal && (!newVal.Id || newVal.Id <= 0)) {
          // Only on new items.
          var urlVal = newVal.Title.toLowerCase()
            .replace(/ /g, "-")
            .replace(/[^\w-]+/g, "");
          if (this.AutoSlug === true) newVal.Slug = urlVal;
        }
        instance.tagsUpdated(newVal.RelatedTags);
      },
      immediate: true,
      deep: true,
      flush: "post",
    },
    AIResolvedSkillset(newVal) {
      if (newVal && newVal.length > 0) {
        this.$set(
          this,
          "NiceToHaveSkills",
          this.FilterSkillsByRelationType("NICE TO HAVE")
        );
        this.$set(this, "MustSkills", this.FilterSkillsByRelationType("MUST"));
        this.$set(
          this,
          "CreateSkills",
          this.FilterSkillsByRelationType("CREATE")
        );
      } else {
        this.$set(this, "NiceToHaveSkills", []);
        this.$set(this, "MustSkills", []);
        this.$set(this, "CreateSkills", []);
      }
    },
  },
  props: [
    "isActive",
    "UpdateActive",
    "currentItem",
    "GetItemsPromise",
    "CommitItemsPromise",
    "ItemsUpdated",
    "AllowEmbedNotifications",
    "AllowNotifyChecked",
    "EmailsToNotify",
    "Save",
    "IsSidePopUp",
    "ParentNode",
    "TriggerUrl",
  ],
  components: {
    quillEditor,
    VueSimpleSuggest,
    RelatedItemsDropdown,
    TagsService,
    TagList,
    SkillExpandable,
  },
};
</script>
<style lang="scss">
@import "@/assets/scss/vuesax/extraComponents/autocomplete.scss";
</style>
<style scoped>
*>>>.ql-editor {
  min-height: 200px;
}

*>>>.gap-section-title {
  font-weight: 900;
  margin-top: 10px;
  margin-bottom: 20px;
}

*>>>ul.suggestions {
  background: white;
  border: 1px solid var(--primary) !important;
  position: absolute;
  z-index: 9999;
}

*>>>li.suggest-item.hover,
*>>>li.suggest-item.selected {
  color: white;
}

*>>>.vue-simple-suggest {
  width: 100%;
}

*>>>.side-popup {
  position: absolute !important;
  left: auto !important;
  right: 0px !important;
  min-width: 300px;
}

.side-popup .vs-popup {
  right: 0px !important;
  position: absolute !important;
}

*>>>.side-popup>>>.vs-popup {
  max-width: 100%;
  width: 100%;
  max-height: 100%;
  height: calc(100% - 20px);
}

.side-popup>>>.vs-popup--background {
  display: none;
}

.side-popup>>>.vs-popup--header {
  background-color: var(--primary) !important;
  color: white;
}

.side-popup>>>.vs-popup--title h3 {
  color: white;
}
</style>
